<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<!-- <div id="panelList" class="card-body  panel-collapse collapse in show"> -->
									<div class="form-row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.personId')}}
												</label>
												<auto-search :paramsSearch="paramsSearch" @updateOnClick="addPrsPerson"/>
												<!-- <input type="text" v-model="instance.personId" class="form-control" hidden=""/>								 -->
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
												</label>
												<select v-model="instance.prsStore" class="form-control" multiple>
													<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id">
													{{ prsStore.storeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servStatus')}}
												</label>
												<select v-model="instance.servStatus" class="form-control" multiple>
													<option v-for="servStatus in servStatusList" :value="servStatus.id" :key="servStatus.id">
													{{ servStatus.statusName}}
													</option>
												</select>										
											</div>
										</div>
										
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.username')}}
												</label>
												<select v-model="instance.username" class="form-control" multiple>
													<option v-for="user in userList" :value="user" :key="user">
														{{ user}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.orderNumber')}}
												</label>
												<input type="text" v-model="instance.orderNumber" class="form-control" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.dateEntryAfter')}}</label>
												<input type="date" v-model="instance.dateEntryAfter" class="form-control" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.dateEntryBefore')}}</label>
												<input type="date" v-model="instance.dateEntryBefore" class="form-control" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountInf', { obj: $t(instanceClassAttr.instanceClass+'.cost')} ) }}</label>
												<input type="number" step="any" v-model="instance.costInf" class="form-control" @input="amountToLetter($event, 'inf')" @change="amountLetter = {} "/>
												<span v-if="amountLetter && amountLetter.inf != '' " class="amount-letter">
													{{amountLetter.inf}}
												</span>
											</div>
											
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountEq', { obj: $t(instanceClassAttr.instanceClass+'.cost')})}}</label>
												<input type="number" step="any" v-model="instance.costEq" class="form-control" @input="amountToLetter($event, 'eq')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.eq != '' " class="amount-letter">
													{{amountLetter.eq}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountSup', { obj: $t(instanceClassAttr.instanceClass+'.cost')})}}</label>
												<input type="number" step="any" v-model="instance.costSup" class="form-control" @input="amountToLetter($event, 'sup')" @change="amountLetter = {} "/>
												<span v-if="amountLetter && amountLetter.sup != '' " class="amount-letter">
													{{amountLetter.sup}}
												</span>
											</div>
										</div>

									</div> <!--end form-row-->
									<div style="text-align:center">
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>
										&ensp;
										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

									<!-- </div> -->
								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<!-- STATS -->
						<div>
							<chart
								:typeStats="typeStats"
								:chartData="chartData"
								:chartOptions="chartOptions"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<div class="datatable">
							<datatable-instance 
								:instanceClassAttr="instanceClassAttr" ref="componentDatatableInstance"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>

		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import AutoSearch from '@/components/templates/AutoSearch.vue';
	import Chart from '@/components/templates/charts/Chart.vue';
	export default {
		name: 'prodOrderList',
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'auto-search': AutoSearch,
			'chart': Chart
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('prodorder.label'),
				pageTitle: this.$t('prodorder.list'),
				pageIcon: 'list',
				instanceClassAttr: {
					instanceClass: 'prodorder',
					routerShow: 'prodordershow',
					titleIndex: 'nav.serv',
					iconClass: 'folder',
					actCol: {
						actDisplay: true,
						// actAlign: 'right',
						thCol: '10%', 
						actAdd: true, 
						actGet: true, 
						actEdit: true, 
						actDel: true, 
						actPrint: 'reportlist'
					},
					attrsList: [
						{attrName: 'prsStoreLib', attrCol: '12%', searchable: false, sortable: true},
						{attrName: 'orderNumber', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'orderDate', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'person', attrCol: '15%', searchable: false, sortable: true, attrRep:'getPrsPerson()'},
						{attrName: 'cost', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'prodOrderItem', attrCol: '35', searchable: false, sortable: true},
						{attrName: 'servStatusLib', attrCol: '7%', searchable: false, sortable: true, attrRep:''},
						{attrName: 'usernameLib', attrCol: '10%', searchable: true, sortable: false, attrRep:''}
					]
				},
				paramsSearch: {
					placeholder: 'Search Client',
					instanceClass: 'prsperson',
					attrsSearch : ['firstName', 'lastName'],
					attrView: 'fullName',
					filterList: [],
					btnReturn: false,
					icon: 'user',
				},
				
				instance: {},
				prsStoreList: [],
				userList: [],
				servStatusList: [],
				amountLetter: {},
				chartOptions: {
					title: 'Statistique des ventes par ',
					hAxis: {title: 'Client'},
					vAxis: {title: 'Montant'}
				},
				chartData: [],
				typeStats: [
					{id: 'prsPerson', label: this.$t('prodorder.personId')},
					{id: 'prsStore', label: this.$t('prsstore.label')},
					// {id: 'libShort', label: 'Arrêté'}
				],
				typeStat: 'prsPerson'
			}
		},
		async mounted () {
			this.$store.dispatch('loading')
			this.$nextTick(() => {
				this.$store.dispatch('unloading')
			})
			if(this.$store.getters.loggedIn) {
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
					this.instance.prsStore = []
					if(!this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
						this.prsStoreList = this.prsStoreList.filter(item => item.id == this.$store.getters.prsInfo.prsStore)
						this.instance.prsStore.push(this.$store.getters.prsInfo.prsStore)
					}
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})
				// GET LIST user
				await this.$store.dispatch('axiosGet', {
					domain: 'user'
				})
				.then(response => {
					this.instance.username = []
					response.data.forEach(element => {
						this.userList.push(element.username)
						if(this.$store.getters.isAuthorized(['ROLE_VENTE'])){
							this.userList = this.userList.filter(item => item == this.$store.getters.username)
							this.instance.username.push(this.$store.getters.username)
						}
					});
				})
				.catch(error => {
					console.log('error catch userList == ', error.message)
				})
				
				// GET LIST servStatusList
				await this.$store.dispatch('axiosGet', {
					domain: 'servstatus'
				})
				.then(response => {
					this.servStatusList = response.data
				})
				.catch(error => {
					console.log('error catch servStatusList == ', error.message)
				})
				// GET LIST prsPersonList
				this.getPersonList()
				this.search()
			}
			// this.reset()
		},
		methods: {
			reset(){
				this.instance = {
					personId: '',
					prsStore: [],
					username: [],
					servStatus: [],
					orderNumber: '',
					dateEntryAfter:'',
					dateEntryBefore:'',
					costSup: '',
					costEq: '',
					costInf: '',
				};
			},
			async getPersonList(){
				let strParams = "typeRender=list"
				strParams = strParams+"&attrOrder=firstName&typerOrder=asc"			
				// CL -> 2
				strParams = strParams+"&aliasList=_prsType,_prsStore"
				strParams = strParams+"&params1=_prsType.id&valParams1="+2+"&logParams1=eqL"
				if(this.prsStoreSelected && this.prsStoreSelected != null)
					strParams = strParams+"&params2=_prsStore.id&valParams2="+this.prsStoreSelected+"&logParams2=eqL"
				
				strParams = strParams+"&params3=active&valParams3="+true+"&logParams3=eqB"
					
				await this.$store.dispatch('axiosGet', { 
					url: '/api/prsperson/getbycriteria?' + strParams
				})
				.then(response => {
					this.paramsSearch.filterList = response.data
					// console.log('this.paramsSearch.filterList = ', this.paramsSearch.filterList)
				})
				.catch(error => {
					console.log('error catch paramsSearch.filterList == ', error.message)
				})

			},
			addPrsPerson(row){
				if(row){
					this.instance.personId = row.id?.toString()
					this.instance.fullName = row.fullName
				}
				else{
					this.instance.personId = ''
					this.instance.fullName = ''
				}
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async search() {
				let strParamsForms = "";
				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';
				// Date super
				strParamsForms = strParamsForms+"&params1=orderDate&valParams1="+this.instance.dateEntryAfter+"&logParams1=geD"
				if(this.instance.dateEntryAfter){
					detailsTopC2 = '<i>'+this.$t('default.dateEntryAfter')+' </i><b> '+ this.$moment(this.instance.dateEntryAfter).format(this.$store.getters.formatDateShort) + '</b>'
				}
				// Date inf
				strParamsForms = strParamsForms+"&params2=orderDate&valParams2="+this.instance.dateEntryBefore+"&logParams2=leD"
				if(this.instance.dateEntryBefore){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + ' - '
					else
						detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryAfter')+' </i><b> ... </b>'

					detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryBefore')+' </i><b> '+ this.$moment(this.instance.dateEntryBefore).format(this.$store.getters.formatDateShort) + '</b>'
				}
				strParamsForms = strParamsForms+"&params3=prsStore.id&valParams3="+this.instance.prsStore +"&logParams3=inL"
				if(this.instance.prsStore && this.instance.prsStore.length >0 ){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.prsStoreList, this.instance.prsStore, 'storeName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.prsStore')+'(s) : </i><b>'+strLibs + '</b>'
				}
				strParamsForms = strParamsForms+"&params4=servStatus.id&valParams4="+this.instance.servStatus +"&logParams4=inL"

				if(this.instance.servStatus && this.instance.servStatus.length >0 ){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servStatusList, this.instance.servStatus, 'statusName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servStatus')+'(s) : </i><b>'+strLibs + '</b>'
				}

				strParamsForms = strParamsForms+"&params5=personId&valParams5="+this.instance.personId +"&logParams5=eq"
				if(this.instance.personId && this.instance.personId !== ''  && this.instance.fullName !== ''){
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.personId')+' : </i><b>'+ this.instance.fullName + '</b>'

				}


				strParamsForms = strParamsForms+"&params6=username&valParams6="+this.instance.username +"&logParams6=inS"
				
				strParamsForms = strParamsForms+"&params7=orderNumber&valParams7="+this.instance.orderNumber +"&logParams7=like"

				// Amout super
				strParamsForms = strParamsForms+"&params8=cost&valParams8="+this.instance.costSup+"&logParams8=geDo"
				if(this.instance.costSup){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.cost')+' >= </i><b>'+this.$store.getters.formatAmount(this.instance.costSup) + '</b>'
				}
				// Amout equal
				strParamsForms = strParamsForms+"&params9=cost&valParams9="+this.instance.costEq+"&logParams9=eqDo"
				if(this.instance.costEq){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.cost')+' = </i><b> '+this.$store.getters.formatAmount(this.instance.costEq) + '</b>'
				}
				// Amout inf
				strParamsForms = strParamsForms+"&params10=cost&valParams10="+this.instance.costInf+"&logParams10=leDo"
				if(this.instance.costInf){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.cost')+' <;= </i><b> '+this.$store.getters.formatAmount(this.instance.costInf) + '</b>'
				}

				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2

				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
			drawChart(val) {
				if(val && !Array.isArray(val))
					this.typeStat = val
				
				// default values
				let statLabel = ["Type dépense", "Montant par type de dépense"] 
				let attrKey = 'person'
				let attrValue = 'cost'
				if(this.typeStat === 'prsPerson' )
					statLabel = ["Client", "Montant par Client"]
				else if(this.typeStat === 'prsStore' ){
					statLabel = ["Store", "Montant par Store"]
					attrKey = 'prsStoreLib'
				}
				
				var dataList = this.$refs.componentDatatableInstance.drawChart(attrKey, attrValue, null)
				this.chartData = [ statLabel ]
				dataList?.forEach(data => {
					this.chartData.push(data);	
				});
			},

		}
		
	}

</script>